IN.App.InputemailController = Ember.Controller.extend(IN.SmsVerificationHelper, {
	useremail: null,
	tooltiperror: "Gebruiker niet gevonden",
	error: false,
	errorMessage: null,
	actions:{
		postemail: function(){
			var self = this;

			var data = {
				"email": encodeURIComponent(self.get('useremail'))
			}

			$.ajax({
				url: '/v1/auth/password/request_reset',
				data: JSON.stringify(data),
				type: 'POST',
				dataType: "json"
			}).then(function(response) {

				self.transitionToRoute("detailssentlost");

			}, function(xhr) {
				if(xhr.status === 404) {
					self.set('error', true);
					self.set('errorMessage', 'Deze gebruiker bestaat niet! Probeer het nogmaals.');
				}
			});

		}
	}

});
